var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"nodatass"},[_c('div',[_c('img',{attrs:{"src":require("@/assets/nodatas.png")}}),_c('div',{staticClass:"notext"},[_vm._v("暂无数据")])])])
}]

export { render, staticRenderFns }